import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    width: _ctx.size,
    height: _ctx.size,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M21.9999 0.333496C10.0399 0.333496 0.333252 10.0402 0.333252 22.0002C0.333252 33.9602 10.0399 43.6668 21.9999 43.6668C33.9599 43.6668 43.6666 33.9602 43.6666 22.0002C43.6666 10.0402 33.9599 0.333496 21.9999 0.333496ZM24.1666 32.8335H19.8333V28.5002H24.1666V32.8335ZM24.1666 24.1668H19.8333V11.1668H24.1666V24.1668Z",
      fill: _ctx.color
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}